import { render, staticRenderFns } from "./SignerDialogComponent.vue?vue&type=template&id=369ead5a&scoped=true&"
import script from "./SignerDialogComponent.vue?vue&type=script&lang=js&"
export * from "./SignerDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./SignerDialogComponent.vue?vue&type=style&index=0&id=369ead5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369ead5a",
  null
  
)

export default component.exports